<template>
    <div>
        <b-card no-body class="p-0" v-if="liberaInvestimentos">
            <b-alert v-if="edicaoAdminPropostaAprovada" show variant="warning" class="m-3">
                Proposta aprovada: edição liberada somente para administrador. Após salvar, gere uma nova versão do XML do projeto para que os valores corrigidos sejam enviados.
            </b-alert>
            <b-tabs card class="p-0 investimentos" justified>
                <b-tab :title="tab.titulo" v-for="tab in investimentos.rubricas" :key="tab.titulo" class="p-0">
                    <div>
                        <h6 v-if="!investimentos[tab.investimento]" class="p-3">Sem dados!</h6>
                        <investimento-table :aprovada="!edicaoLiberada" :rubrica="tab.rubrica" v-if="investimentos[tab.investimento]" :investimentos="investimentos[tab.investimento]" :ref="tab.investimento" :endpoint="endpoint"/>
                    </div>
                </b-tab>
            </b-tabs>
            <div class="p-3">
                <b-button v-if="edicaoLiberada" variant="success" @click="salvarTodos()" class="mr-2">
                    <i class="fa-solid fa-check mr-2"></i>
                    Salvar
                </b-button>
            </div>
        </b-card>
    </div>
</template>
<script>
import PropostaService from "@/common/services/proposta/proposta.service";
import helpers from "@/common/utils/helpers";
import investimentoTable from "./components/investimentoTable";
import cloneDeep from "lodash/cloneDeep";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

export default {
    mixins: [AlertasMixin],
    components: {
        investimentoTable
    },
    props:{
        propostaId : {
            type : String,
            required : true
        },
        endpoint : {
            type: String,
            required: true
        },
        aprovada: {
            type: Boolean,
            default: false
        }
    },
    data : () =>({
        investimentos : {
            rubricas: [],
        },
        salvos : 0
    }),
    methods :{
        salvarTodos(){
            this.confirmar("Confirmar","Deseja salvar as alterações?").then(confirmado => {
                if(confirmado){
                    this.salvos = 0;
                    let form = cloneDeep(this.investimentos);
                    let requisicoes = form.rubricas.map(element => {
                        form[element.investimento].propostaEmpresaProponenteId = this.propostaId;
                        form[element.investimento].propostaEmpresaCooperadaId = this.propostaId;
                        if(
                            form[element.investimento].investimentoProposta == null &&
                            form[element.investimento].investimentoPropostaCooperada == null &&
                            form[element.investimento].investimentoPropostaProponente == null &&
                            form[element.investimento].investimentosPropostasExecutoras == null
                        ){
                            this.salvos++;
                            return Promise.resolve(null);
                        }
                        return PropostaService.salvarInvestimento(element.rubrica,form[element.investimento]).then(() => {
                            this.salvos++;
                            this.buscarInvestimento(element);
                            return null;
                        }).catch(err => {
                            let mensagem = err.response && err.response.status == 400
                                ? [].concat(err.response.data.errors).join("<br>")
                                : "Ocorreu um erro ao salvar o investimento!";
                            return `<b>${element.titulo}</b>: ${mensagem}`;
                        });
                    });

                    Promise.all(requisicoes).then(resultados => {
                        let erros = resultados.filter(el => el);
                        if(erros.length){
                            let complemento = erros.length < resultados.length ? "<br><br>As demais rubricas foram salvas." : "";
                            this.alertaErro(`${erros.join("<br>")}${complemento}`);
                            return;
                        }
                        this.alertaSucesso("Salvo com sucesso!");
                        this.$emit("update");
                    });
                }
            });
        },

        formatarValor : function(form){

            if(!form)
                return form;

            if(form.investimentosPropostasExecutoras)
            form.investimentosPropostasExecutoras.forEach(element => {
                element.valorAlocado = helpers.formatarValor(element.valorAlocado || "0");
            });

            if(form.investimentoPropostaCooperada)
                form.investimentoPropostaCooperada.valorAlocado = helpers.formatarValor(form.investimentoPropostaCooperada.valorAlocado || "0");

            if(form.investimentosPropostasCooperadas)
                form.investimentosPropostasCooperadas.forEach(element => {
                    element.valorAlocado = helpers.formatarValor(element.valorAlocado || "0");
                });

            if(form.investimentoPropostaProponente)
                form.investimentoPropostaProponente.valorAlocado = helpers.formatarValor(form.investimentoPropostaProponente.valorAlocado || "0");
            
            if(form.investimentoProposta)
            form.investimentoProposta.valorAlocado = helpers.formatarValor(form.investimentoProposta.valorAlocado || "0");

            return form;
        },

        buscarInvestimentos: function(){
            let rubricas = [
                {
                    titulo : 'RH - Recursos humanos',
                    rubrica : 'recurso-humano',
                    investimento : 'recursoHumano',
                    ordem : 1
                },
                {
                    titulo : 'ST - Serviços de terceiros',
                    rubrica : 'servico-terceiro',
                    investimento : 'servicoTerceiro',
                    ordem : 2
                },
                {
                    titulo : 'MC - Materiais de consumo',
                    rubrica : 'material-consumo',
                    investimento : 'materialConsumo', 
                    ordem : 3
                },
                {
                    titulo : 'MPE - Materiais permanentes e equipamentos',
                    rubrica : 'material-permanente-equipamento',
                    investimento : 'materialPermanente',
                    ordem : 4
                },
                {
                    titulo : 'VD - Viagens e diárias',
                    rubrica : 'viagem-diaria',
                    investimento : 'viagemDiarias',
                    ordem : 5
                },
                {
                    titulo : 'OU - Outros',
                    rubrica : 'outro-recurso',
                    investimento : 'outrosRecursos',
                    ordem : 6
                },
            ];

            this.investimentos = {
                rubricas: [],
            };

            rubricas.forEach(rubrica => {
                this.buscarInvestimento(rubrica)
            });
            
        },
        buscarInvestimento(rubrica){
            PropostaService.buscarInvestimento(this.propostaId,rubrica.rubrica).then(response => {       
                let investimento = cloneDeep(this.investimentos);
                if(!investimento.rubricas.find(el => el.rubrica == rubrica.rubrica))
                    investimento.rubricas.push(rubrica);
                investimento[rubrica.investimento] = response.data.data;
                investimento[rubrica.investimento] = this.formatarValor(investimento[rubrica.investimento]);

                if(investimento.rubricas.length == 6){
                    investimento.rubricas.sort((a,b) => { return a.ordem - b.ordem; });
                }
                    

                this.investimentos = investimento;

            })
        },
        montar(){
            PropostaService.setEndpoint(this.endpoint);
            this.buscarInvestimentos();
        }
    },
    mounted(){
        
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('PropostaInvestimento');
        },
        ehAdmin() {
            return this.$store.getters['app/ehAdmin'];
        },
        edicaoLiberada() {
            return (!this.aprovada || this.ehAdmin) && this.permissao.u;
        },
        edicaoAdminPropostaAprovada() {
            return this.aprovada && this.ehAdmin;
        },
        liberaInvestimentos : function(){
            return this.investimentos.rubricas.length == 6
        }
    }
}
</script>
<style>
    .investimentos .card-header {
        background: #f3f2f2; border-bottom: 1px solid #e5e5e5;
    }

    .investimentos .card-header-tabs{
        align-items: end;
    }
</style>